import type { CartItemType } from '@zola-helpers/client/dist/es/@types/cart';

export const isDigitalGreetingCard = (item: CartItemType) =>
  item.brandName === 'Zola Digital Greeting Card';
